"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var core_1 = require("@angular/core");
var operators_1 = require("rxjs/operators");
var from_1 = require("rxjs/observable/from");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var HttpEjusticeNotificationService = /** @class */ (function () {
    function HttpEjusticeNotificationService(http, applicationPropertiesService) {
        this.http = http;
        this.applicationPropertiesService = applicationPropertiesService;
        this.serviceUrlKey = 'cms-service-url';
        this.serviceUrl$ = from_1.from(this.applicationPropertiesService.getProperty(this.serviceUrlKey));
    }
    HttpEjusticeNotificationService.prototype.getNotificationLogs = function (categoryId, instanceId, isWithRelatedEntities, paging) {
        var _this = this;
        return this.serviceUrl$.pipe(operators_1.switchMap(function (cmsServiceUrl) {
            var params = {
                categoryId: categoryId,
                'isWithRelatedEntities': isWithRelatedEntities + '',
                'instanceId': instanceId + '',
                'paging': JSON.stringify(paging)
            };
            return _this.http.get(cmsServiceUrl + "/notifications", {
                params: params
            });
        }));
    };
    HttpEjusticeNotificationService.prototype.search = function (categoryId, instanceId, isWithRelatedEntities, pagingCriteria, searchModel) {
        var _this = this;
        return this.serviceUrl$.pipe(operators_1.switchMap(function (cmsServiceUrl) {
            var body = {
                categoryId: categoryId,
                isWithRelatedEntities: isWithRelatedEntities,
                instanceId: instanceId,
                pagingCriteria: pagingCriteria,
                searchTerm: searchModel.term,
                statusIds: searchModel.statusIds,
                sourceTypeId: searchModel.sourceTypeId
            };
            return _this.http.post(cmsServiceUrl + "/notifications/search", body);
        }));
    };
    HttpEjusticeNotificationService.prototype.getNotificationSourcesTypes = function () {
        var _this = this;
        return this.serviceUrl$.pipe(operators_1.switchMap(function (cmsServiceUrl) { return _this.http.get(cmsServiceUrl + "/notifications/source-types"); }));
    };
    HttpEjusticeNotificationService.prototype.getNotificationStatuses = function () {
        var _this = this;
        return this.serviceUrl$.pipe(operators_1.switchMap(function (cmsServiceUrl) { return _this.http.get(cmsServiceUrl + "/notifications/statuses"); }));
    };
    HttpEjusticeNotificationService.prototype.getAttachmentConfig = function () {
        var _this = this;
        return this.serviceUrl$.pipe(operators_1.switchMap(function (cmsServiceUrl) { return _this.http.get(cmsServiceUrl + "/email-attachment-config"); }));
    };
    HttpEjusticeNotificationService.prototype.sendEmail = function (rootEntityCategoryId, rootEntityId, emails, subject, body, documentsIds, isSendAsAttachment) {
        var _this = this;
        if (isSendAsAttachment === void 0) { isSendAsAttachment = false; }
        var mailDto = {
            to: emails,
            subject: subject,
            body: body,
            documentsIds: documentsIds,
            rootEntityCategoryId: rootEntityCategoryId,
            rootEntityInstanceId: rootEntityId,
            isSendAsAttachment: isSendAsAttachment
        };
        return this.serviceUrl$.pipe(operators_1.switchMap(function (cmsServiceUrl) { return _this.http.post(cmsServiceUrl + "/emails", mailDto); }));
    };
    HttpEjusticeNotificationService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient, idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], HttpEjusticeNotificationService);
    return HttpEjusticeNotificationService;
}());
exports.HttpEjusticeNotificationService = HttpEjusticeNotificationService;
//# sourceMappingURL=http-ejustice-notification.service.js.map